import * as React from "react"
import { IconProps } from "./IconProps"

export const ValidationIcon = (props: IconProps) => {
  const { color = "currentColor" } = props

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 4.5H22.083C22.6644 4.5 23.099 5.04652 22.9804 5.62871L21.3254 13.7537C21.2368 14.1884 20.8622 14.5 20.428 14.5H7.7711L8.22943 17H19.5368C19.9734 17 20.3272 17.3082 20.4262 17.7083C20.8827 18.1625 21.1667 18.7971 21.1667 19.5C21.1667 20.8807 20.0723 22 18.7222 22C17.3722 22 16.2778 20.8807 16.2778 19.5C16.2773 19.0611 16.3904 18.6298 16.6056 18.25H11.061C11.2762 18.6298 11.3893 19.0611 11.3889 19.5C11.3889 20.8807 10.2945 22 8.94443 22C7.59441 22 6.49999 20.8807 6.49999 19.5C6.49999 18.8523 6.74081 18.2623 7.13581 17.8182L4.46499 3.25H1.45833C1.20522 3.25 1 3.04012 1 2.78125V2.46875C1 2.20988 1.20522 2 1.45833 2H4.71868C5.15979 2 5.53833 2.32133 5.61965 2.76473L5.93777 4.5H8V5.75H6.16694L7.54193 13.25H20.1795L21.7073 5.75H20V4.5ZM8.94443 20.75C9.61837 20.75 10.1667 20.1893 10.1667 19.5C10.1667 18.8107 9.61837 18.25 8.94443 18.25C8.27049 18.25 7.72221 18.8107 7.72221 19.5C7.72221 20.1893 8.27049 20.75 8.94443 20.75ZM17.5 19.5C17.5 20.1893 18.0483 20.75 18.7222 20.75C19.3961 20.75 19.9444 20.1893 19.9444 19.5C19.9444 18.8107 19.3961 18.25 18.7222 18.25C18.0483 18.25 17.5 18.8107 17.5 19.5Z"
        fill={color}
      />
      <path
        d="M12.363 8.17167L9.85429 5.73917L9 6.56167L12.363 9.8225L19.5823 2.8225L18.7341 2L12.363 8.17167Z"
        fill={color}
      />
    </svg>
  )
}
